const Terms = () => {
  return (
    <>
      <p className="my-2">
        Manchmal ist es nicht einfach, die richtigen Worte zu finden: Die Aktion
        „Dankesbotschaften mit der Herzlichen Intelligenz von merci“ soll dabei
        helfen! Zweck der Aktion ist es, den Teilnehmer dabei zu unterstützen,
        für bestimmte positive Anlässe eine personalisierte Dankesbotschaft zu
        formulieren.
      </p>

      <h2 className="my-2 font-semibold">1. Allgemeine Bedingungen</h2>
      <p className="my-2">
        Veranstalter der Aktion „Dankesbotschaften mit der Herzlichen
        Intelligenz von merci“ (die „<strong>Aktion</strong>“) ist die AUGUST
        STORCK KG, Waldstraße 27, 13403 Berlin (im Folgenden „
        <strong>Storck</strong>“). Es handelt sich hierbei um eine Online-Aktion
        auf der Website{" "}
        <a href="https://www.herzliche-intelligenz.merci.de" target="_blank">
          www.herzliche-intelligenz.merci.de
        </a>
        .
      </p>
      <p className="my-2">
        Mit der Teilnahme an der Aktion erklärt sich der Teilnehmer mit diesen
        Teilnahmebedingungen einverstanden.
      </p>

      <h2 className="my-2 font-semibold">2. Teilnahmeberechtigung</h2>
      <p className="my-2">
        Minderjährige bedürfen zur Teilnahme der Zustimmung ihrer
        Sorgeberechtigten. Die Teilnahme ist nur innerhalb Deutschlands möglich.
      </p>

      <p className="my-2">
        Eine Teilnahme ist nur höchstpersönlich möglich. Eine Teilnahme unter
        Einsatz automatisierter Dienste, „Bots“ oder ähnlichem sowie eine
        Teilnahme, die zur Beeinträchtigung oder Unterbrechung der Aktion bzw.
        der ihr zugrunde liegenden Systeme führt, insbesondere die Beschränkung
        oder Umgehung von Schutzmaßnahmen oder Sicherheitsvorkehrungen, ist
        nicht gestattet.{" "}
      </p>

      <h2 className="my-2 font-semibold">3. Teilnahme und Ablauf der Aktion</h2>
      <p className="my-2">
        Um an der Aktion teilzunehmen, besucht der Teilnehmer die Website{" "}
        <a href="http://www.herzliche-intelligenz.merci.de" target="_blank">
          www.herzliche-intelligenz.merci.de
        </a>
        .
      </p>
      <p className="my-2">
        Über die bereitgestellte Eingabemaske gibt der Teilnehmer den Vornamen,
        Spitz- oder Kosenamen des Empfängers der Dankesbotschaft an. Er wählt
        aus einem Drop-down-Menü die Anrede aus, die verwendet werden soll,
        sowie aus einem weiteren Drop-down-Menü, in welcher Beziehung er zum
        Empfänger der Botschaft steht (z.B. „Kollegen“ oder „Familie“). Sodann
        sucht der Teilnehmer sich einen der in einem weiteren Drop-down-Menü
        angebotenen Dankesanlässe aus.{" "}
      </p>
      <p className="my-2">
        Der Teilnehmer stellt dann mithilfe von unterschiedlichen
        „Schiebereglern“ den gewünschten Schreibstil der Botschaft ein (z.B.
        „Seriös“ bis „Vertraut“ oder „Alltäglich“ bis „Episch“). Dies ermöglicht
        es, den Stil der Nachricht individuell anzupassen.{" "}
      </p>
      <p className="my-2">
        Nachdem der Teilnehmer alle relevanten Informationen eingegeben hat,
        klickt er einfach auf „Danke generieren“. Innerhalb von kurzer Zeit wird
        mithilfe der „Herzlichen Intelligenz“ unter Einsatz künstlicher
        Intelligenz eine personalisierte Dankesbotschaft erstellt.{" "}
      </p>
      <p className="my-2">
        Sobald die Dankesbotschaft vollständig erstellt ist, kann der Teilnehmer
        zwischen zwei Optionen wählen:{" "}
      </p>
      <p className="my-2">
        a. Er kopiert den generierten Text per Klick in die Zwischenablage und
        versendet ihn an eine Person seiner Wahl, um ihr „Danke“ zu sagen.
      </p>
      <p className="my-2">
        b. Alternativ wählt er eines der bereitgestellten Grußkarten-Designs aus
        und lädt die Botschaft anschließend als Bilddatei herunter, um diese zu
        versenden und so „Danke“ zu sagen.
      </p>
      <p className="my-2">
        Der Teilnehmer steht dafür ein, dass die von ihm eingegebenen Inhalte
        keine Rechte Dritter (Persönlichkeits-, Urheber- und sonstige
        Schutzrechte) verletzen und stellt STORCK diesbezüglich umfassend von
        möglichen Ansprüchen Dritter frei. Das Verwenden rechtsverletzender,
        sittenwidriger oder anderweitig unzulässiger oder anstößiger Inhalte ist
        nicht gestattet; insbesondere beleidigende, jugendgefährdende,
        rassistische, sexistische, das Produkt oder die Marke betreffend
        negative oder anderweitig diskriminierende aufgenommene Inhalte, die
        gegen Gesetzesvorschriften, fremde Rechte oder diese
        Teilnahmebedingungen verstoßen, sind nicht zu verwenden.{" "}
      </p>
      <p className="my-2">
        Die Teilnahme an der Aktion und die Verwendung der Dankesbotschaft ist
        nur in Übereinstimmung mit diesen Teilnahmebedingungen und zu den in
        diesen Teilnahmebedingungen festgelegten Zwecken gestattet. Insbesondere
        darf die Aktion und insbesondere die Dankesbotschaft nicht für
        rechtswidrige Zwecke genutzt oder in einer Weise verwendet werden, die
        gegen Rechte Dritter verstößt, sie sich aneignet oder diese sonst
        verletzt. Eine Nutzung der Aktion zu gewerblichen oder kommerziellen
        Zwecken, insbesondere ein Verkauf oder eine sonstige kommerzielle
        Nutzung der Dankesbotschaft, ist nicht gestattet.{" "}
      </p>
      <p className="my-2">
        STORCK ist berechtigt, einzelne Personen von der Teilnahme
        auszuschließen, sofern berechtigte Gründe vorliegen, wie z. B. der
        Verstoß gegen die Teilnahmebedingungen oder eine Manipulation.
        Teilnehmer, bei denen der Verdacht auf einen vorsätzlichen oder
        fahrlässigen Missbrauch der Aktion oder auf die Angaben falscher,
        irreführender oder betrügerischer Daten besteht, werden von der
        Teilnahme ausgeschlossen. STORCK behält sich rechtliche Schritte gegen
        diese Teilnehmer vor.{" "}
      </p>

      <h2 className="my-2 font-semibold">
        4. Einsatz von Künstlicher Intelligenz („KI“)
      </h2>
      <p className="my-2">
        Die Dankesbotschaft wird unter Einsatz künstlicher Intelligenz erstellt.
      </p>
      <p className="my-2">
        Aufgrund des Einsatzes von künstlicher Intelligenz ist es möglich, dass
        die erstellte Dankesbotschaft nicht einzigartig ist.
      </p>
      <p className="my-2">
        Der Einsatz von künstlicher Intelligenz birgt gewisse Risiken,
        insbesondere können Fehler entstehen und/oder die generierte
        Dankesbotschaft falsche und/oder verzerrte Ergebnisse enthalten. Der
        Teilnehmer muss daher die generierte Dankesbotschaft selbst kritisch
        prüfen und ist für die Verwendung der Dankesbotschaft selbst
        verantwortlich.{" "}
      </p>

      <h2 className="my-2 font-semibold">5. Sonstiges</h2>
      <p className="my-2">
        Storck behält sich vor, diese Teilnahmebedingungen ohne Vorankündigung
        jederzeit zu ändern und die Aktion ohne Angabe von Gründen für einen
        vorübergehenden Zeitraum auszusetzen oder zu beenden, insbesondere wenn
        die ordnungsgemäße Durchführung aus technischen, rechtlichen oder
        sonstigen Gründen nicht mehr gewährleistet werden kann.{" "}
      </p>
      <p className="my-2">
        Für Datenverluste, insbesondere im Wege der Datenübertragung, und andere
        technische Defekte übernehmen Storck und die beteiligten Partner keine
        Haftung.{" "}
      </p>
      <p className="my-2">
        Der Rechtsweg ist ausgeschlossen. Ausschließliches anwendbares Recht ist
        das Recht der Bundesrepublik Deutschland.{" "}
      </p>

      <h2 className="my-2 font-semibold">6. Datenschutz</h2>
      <p className="my-2">
        Mit der Aktion „Dankesbotschaften mit der Herzlichen Intelligenz von
        merci“ werden keine personenbezogenen Daten der Teilnehmer verarbeitet.
        Über die bereitgestellte Eingabemaske können und sollen im Feld „Name“
        lediglich Vornamen oder Kose-/Spitznamen eingegeben werden, die keinen
        Rückschluss auf eine konkrete Person zulassen.
      </p>
      <p className="my-2">
        Allgemeine Informationen zum Datenschutz finden Sie unter:
      </p>
      <p className="my-2">
        <a
          href="http://www.merci.de/de/datenschutz"
          target="_blank"
          className="text-muted-foreground hover:text-secondary-foreground active:text-cta-active focus:text-cta-click underline underline-offset-4"
        >
          www.merci.de/de/datenschutz
        </a>
        .
      </p>
      <br />
    </>
  );
};

export default Terms;
